import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import {dayjsFromSeconds, formatDate} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault, renderSelf} from 'views/Shared'
import {renderIf} from "../../Shared";
import {GoDotFill} from "react-icons/go";
import {RiDoubleQuotesL, RiDoubleQuotesR} from "react-icons/ri";

const ItemDescription = ({
                             title,
                             description,
                             Wrapper = 'div',
                             contentClassName = 'font-semibold text-color-100',
                         }) => {
    const t = useTranslate()
    return (
        <Wrapper className="space-x-1 text-xs italic">
            <GoDotFill size={10} className="text-color-400"/>
            <span className="text-color-400 ">
                {`${t(title)} : `}
            </span>
            <span className={contentClassName}>
                {description}
            </span>
        </Wrapper>
    )
}

export const renderExaminationPaperItem = ({translate: t, renderContextMenu = NullAsDefault}) => (item, index) => {
    const {examination, examinee_name} = item ?? {}

    return (
        <div
            key={index}
            className="p-4 custom-item-render transition-all duration-300 relative list-item">
            <div className="mb-1 mr-5 space-x-1 text-base tracking-wide">
                <span className="font-medium text-gray-500 whitespace-no-wrap">
                    {t('exam of')}
                </span>
                <span className="font-bold text-gray-900 italic">
                    <RiDoubleQuotesL size={8} style={{marginRight: 2}} className="mb-1"/>
                    <span className="text-gray-800">
                        {item?.patron_saint_name ? item?.patron_saint_name : item?.prefix_title}{' '}
                    </span>
                    {examinee_name}
                    <RiDoubleQuotesR size={8} style={{marginLeft: 2}} className="mb-1"/>
                </span>
                <span className="font-medium text-gray-500">
                    {t('in the {n} test', {
                        n: (
                            <Link
                                to={getLinkToDetail(item)}
                                className="ml-1 font-bold text-blue-600 no-underline">
                                {getTitle(examination)}
                            </Link>
                        )
                    })}
                </span>
            </div>
            <div className="my-2 border-b border-color-50"/>
            <div className="ml-0 md:ml-2 grid grid-cols-1 md:grid-cols-2 gap-2">
                {[
                    {
                        label: 'correct answers',
                        name: 'total_corrects',
                        defaultValue: 0,
                    },
                    {
                        label: 'ranking',
                        name: 'score_ranking',
                        defaultValue: t('no data'),
                        transform: (value) => {
                            let _class
                            switch (value) {
                                case 'passed' :
                                    _class = 'font-bold text-blue-600'
                                    break;
                                case 'credit' :
                                    _class = 'font-bold text-orange-600'
                                    break;
                                case 'distinction' :
                                    _class = 'font-bold text-green-600'
                                    break;
                                case 'failed' :
                                    _class = 'font-bold text-red-300'
                                    break;
                                default :
                                    _class = 'font-medium text-color-100'
                                    break;
                            }
                            return (
                                <span className={_class}>{value ? t(value) : t('no data')}</span>
                            )
                        }
                    },
                    {
                        label: 'total point',
                        name: 'final_score',
                        defaultValue: 0,
                    },
                    {
                        label: 'time for test',
                        name: 'working_time_in_seconds',
                        transform: (value) =>
                            dayjsFromSeconds(value)?.format('HH:mm:ss'),
                    },
                    {
                        label: 'start',
                        name: 'started_at',
                        defaultValue: t('no data'),
                        transform: (value) =>
                            value ? formatDate(value, 'HH:mm - DD/MM/YYYY') : null,
                    },
                    {
                        label: 'end',
                        name: 'finished_at',
                        defaultValue: t('no data'),
                        transform: (value) =>
                            value ? formatDate(value, 'HH:mm - DD/MM/YYYY') : null,
                    },
                ].map(
                    (
                        {
                            name,
                            label,
                            defaultValue,
                            transform = renderSelf,
                            render = (child, params) => child,
                            ...rest
                        },
                        index,
                        array
                    ) => {
                        const value = _.get(item, name)
                        return render(
                            <ItemDescription
                                key={index}
                                title={label}
                                description={transform(value) || defaultValue}
                            />,
                            {
                                name,
                                value,
                                transform,
                                defaultValue,
                                getValue: (name) => _.find(array, {name}),
                                ...rest,
                            }
                        )
                    }
                )}
            </div>
            <div className="absolute right-8 top-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}
